import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './authentication/auth.guard'

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { OpenLayoutComponent } from './layouts/open/open-layout.component';
import { SetupTutorialComponent } from './setup-tutorial/setup-tutorial.component';
import { CustomizationComponent } from './customization/customization.component';
import { TransparencyComponent } from './transparency/transparency.component';
import { HelpCentralComponent } from './help-central/help-central.component';
import { ReferralComponent } from './referral/referral.component';
import { StoreUserComponent } from './storeUsers/storeUsers.component';
import { CompreDoeComponent } from './compredoe/compredoe.component';
import { LoginComponent } from './pages/login/login.component';
import { SetupComponent } from './setup/setup.component';
import { NewLoginComponent } from './pages/new-login/new-login.component';
import { NewBillingFormComponent } from './shared/payment/new-billing-form/new-billing-form.component';
import { ProductsComponent } from './profile/products/products.component';

// import {MatchFundingComponent} from "./match-funding/match-funding.component";


const routes: Routes = [
    {
        path: '',
        redirectTo: 'profile/onboarding',
        pathMatch: 'full'
    },
    {
        path: 'fatura',
        component: OpenLayoutComponent,
        children: [{
            path: '',
            loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule)
        }]
    },
    {
        path: 'fatura',
        canActivate: [AuthGuard],
        component: OpenLayoutComponent,
        children: [{
            path: '',
            loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule)
        }]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        component: AdminLayoutComponent,
        children: [
            //metodo ideal para deixar os componentes de cada Module ser roteados dentro de seus respectivos Modulos.
            {
                path: '',
                loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
            },
            {
                path: 'company',
                loadChildren: () => import('./company/company.module').then(m => m.CompanyModule)
            },
            {
                path: 'fatura',
                loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule)
            },

            {
                path: 'onboarding',
                loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
            },
            {
                path: 'campaign',
                loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule)
            },
            {
                path: 'transactions',
                loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsModule)
            }, {
                path: 'ngo',
                loadChildren: () => import('./ngo/ngo.module').then(m => m.NgoModule)
            },
            {
                path: 'matchfunding',
                loadChildren: () => import('./match-funding/match-funding.module').then(m => m.MatchFundingModule)
            }, {
                path: 'profile',
                loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
            }, {
                path: 'bot',
                loadChildren: () => import('./bot/bot.module').then(m => m.BotModule)
            }, {
                path: 'setup',
                component: SetupComponent
            }, {
                path: 'api',
                component: SetupTutorialComponent
            }, {
                path: 'referral',
                component: ReferralComponent
            }, {
                path: 'customization',
                component: CustomizationComponent
            },
            // {
            //   path: 'matchfunding',
            //   component: MatchFundingComponent
            // },
            {
                path: 'backers',
                component: StoreUserComponent
            },
            {
                path: 'compredoe',
                component: CompreDoeComponent
            }, {
                path: 'transparency',
                component: TransparencyComponent
            }, {
                path: 'help-central',
                component: HelpCentralComponent
            }, {
                path: 'admin',
                loadChildren: () => import('./administrator/administrator.module').then(m => m.AdministratorModule)
            }, {
                path: 'causes',
                loadChildren: () => import('./causes/causes.module').then(m => m.CausesModule)
            }, {
                path: 'products',
                component: ProductsComponent
            }
        ]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'pages',
            loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
        }]
    },
    {
        path: '**',
        redirectTo: 'profile/onboarding',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutes { }
